export default __webpack_public_path__ + "static/media/3_1.98fe9564.png";